import template from './sw-category-upselling.html.twig'
import './sw-category-upselling.scss'

const { EntityCollection } = Shopware.Data
const { Component } = Shopware
const { mapState } = Shopware.Component.getComponentHelper()

Component.register('sw-category-upselling', {
    template,

    inject: ['repositoryFactory'],

    data() {
        return {
            upselling: null,
        }
    },

    metaInfo() {
        return {
            title: 'Upselling',
        }
    },

    computed: {
        ...mapState(
            () => Shopware.Store.get('swCategoryDetail'),
            [
                'category',
            ],
        ),

        assetFilter() {
            return Shopware.Filter.getByName('asset')
        },

        upsellings() {
            if (!(this.category.extensions && this.category.extensions.zeoCategoryUpsellings)) {
                if (!this.category.extensions) {
                    this.category.extensions = {}
                }
                this.category.extensions.zeoCategoryUpsellings = new EntityCollection(null, 'zeo_product_upselling')
            }
            return this.category.extensions.zeoCategoryUpsellings
        },

        productUpsellingRepository() {
            return this.repositoryFactory.create('zeo_product_upselling')
        },
    },

    methods: {
        onAddUpselling() {
            this.createUpselling()
        },

        createUpselling() {
            const upselling = this.productUpsellingRepository.create(Shopware.Context.api)
            upselling.categoryId = this.category.id
            upselling.position = this.category.extensions.zeoCategoryUpsellings.length + 1
            upselling.type = 'productStream'
            upselling.sortBy = 'name'
            upselling.sortDirection = 'ASC'
            upselling.limit = 24
            this.upsellings.push(upselling)
        },
    },
})
